import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon
// BackdropLoader, toast, BasicTooltip
} from '@livable/saas-react-components';
import { Button, Container, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PropertiesBatchActions } from './PropertiesBatchActions';
import { PropertiesDataGrid } from './PropertiesDataGrid';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { Link as RouterLink } from 'react-router-dom';
export const PropertiesListView = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2;
  let triggerRefresh = _ref.triggerRefresh,
    handleShowEnrollModal = _ref.handleShowEnrollModal,
    handleShowManageAccessModal = _ref.handleShowManageAccessModal,
    handleShowAutoBillingBatchModalModal = _ref.handleShowAutoBillingBatchModalModal,
    openPropertyDetails = _ref.openPropertyDetails;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRows = _useState2[0],
    setSelectedRows = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "".concat(classes.containerDefault, " ").concat(selectedRows.length > 0 ? classes.containerSmall : '')
  }, !!((_store$homeDashboardS = store.homeDashboardStore) !== null && _store$homeDashboardS !== void 0 && (_store$homeDashboardS = _store$homeDashboardS.getCurrentCompanyProperties) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.length) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "residencies-search",
    label: t('portfolios_properties_page.search_for_property'),
    variant: "outlined",
    value: searchKey,
    onChange: e => {
      var _e$target;
      return setSearchKey(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
    },
    fullWidth: true
  })))), /*#__PURE__*/React.createElement(PropertiesDataGrid, {
    isSelectAllPropertiesEnabled: store.homeDashboardStore.selectedPortfolioId === 'all',
    updateRowsCount: setSelectedRows,
    selectedRows: selectedRows,
    setSelectedRows: setSelectedRows,
    searchKey: searchKey,
    propertiesList: (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompanyProperties) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.filter(i => {
      const searchPhrase = new RegExp(searchKey, 'gi');
      return searchKey.length > 0 ? " ".concat(i.dashboard.propertyAddress).search(searchPhrase) > 0 : true;
    }),
    handleShowEnrollModal: handleShowEnrollModal,
    handleShowManageAccessModal: handleShowManageAccessModal,
    handleShowAutoBillingBatchModalModal: handleShowAutoBillingBatchModalModal,
    openPropertyDetails: openPropertyDetails
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.emptyState
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emptyStateContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, " ", t('portfolios_properties_page.new_portfolio'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.emptyStateContainerItem)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('portfolios_properties_page.empty_portfolio_info'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.emptyStateContainerItem, " ").concat(classes.emptyStateContainerItemAddPropertyButton)
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    id: "addNewProperty",
    to: "/new_property",
    size: "regular",
    variant: "actionIcon",
    'custom-attribute': '669-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, " ", t('portfolios_properties_page.add_new_property'))))))), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && !!store.portfoliosMultiActionStore.selectedItems.length && /*#__PURE__*/React.createElement(PropertiesBatchActions, {
    triggerRefresh: triggerRefresh
  }));
});